import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getDefaultPageForUser } from '../utils/navigationHelper';

const DefaultRedirect = () => {
  const { user } = useSelector((state) => state.auth);
  
  const defaultPage = getDefaultPageForUser(user);
  
  return <Navigate to={defaultPage} replace />;
};

export default DefaultRedirect;
